import React from 'react';
import UserJobsContainer from '../../../Containers/UserContainer/Jobs';
import MainLayout from '../../../Components/CommonComponents/Layout/mainLayout';

const UserJobsScreen = () => {
  return <UserJobsContainer />;
};

export default UserJobsScreen;
